<div
  class="mui-hero-page-title__wrapper"
  @pageTitleAnimation
  [class.long-name]="title.length > 30"
  [class.very-long-name]="title.length > 45">
  <h1 class="mui-hero-page-title__title" *ngIf="title">{{ title }}</h1>
  <div class="mui-hero-page-title__divider"></div>
  <h5 class="mui-hero-page-title__subtitle" *ngIf="subtitle">{{ subtitle }}</h5>
</div>
